import { getSectionHeadingPath } from '@utils/apiFunctions';
import httpClient from '@utils/httpClient';
import { pathTypes } from '@utils/sectionEnums';

export function fetchMenuCategoriesApiCall(blockId) {
  return httpClient.get(`api/menu-blocks/${blockId}/categories`);
}

export function createMenuCategoryApiCall(blockId, title) {
  return httpClient.post(`api/menu-blocks/${blockId}/categories`, { Title: title });
}

export function updateMenuCategoryApiCall(blockId, categoryId, title) {
  return httpClient.put(`api/menu-blocks/${blockId}/categories/${categoryId}`, { Title: title });
}

export function deleteMenuCategoryApiCall(blockId, categoryId) {
  return httpClient.delete(`api/menu-blocks/${blockId}/categories/${categoryId}`);
}

export function updateMenuApiCall({
  id,
  isPathDesign,

  headingTitle,
  headingDescription,
  headingTextAlign,
  headingImage,
  headingDivider,

  menuType,
  pdfUrl,
  layout,
  categories,
  items,
}) {
  return httpClient.put(getSectionHeadingPath(pathTypes.menu, isPathDesign), {
    id,
    headingTitle,
    headingDescription,
    headingTextAlign,
    headingImage,
    headingDivider,
    menuType,
    pdfUrl,
    layout,
    categories,
    items,

    containerDesign,
    itemDesign,
    buttonDesign,

    designView,
    designLayout,
    itemTextAlign,
    itemTitleSize,
    itemLayout,
    itemFields,
    itemColumns,
  });
}
